import { render, staticRenderFns } from "./sk-img.vue?vue&type=template&id=23e6c592&scoped=true&"
import script from "./sk-img.vue?vue&type=script&lang=js&"
export * from "./sk-img.vue?vue&type=script&lang=js&"
import style0 from "./sk-img.vue?vue&type=style&index=0&id=23e6c592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6c592",
  null
  
)

export default component.exports